
import React, { Component } from 'react';
import {  ImagenesRutas } from '../../../request/RutasConfig.jsx';





const LoaderHOC = (propName) => (WrapedComponent) => {
    return class LoaderHOC extends Component {


        cargandoSector(pName, pVerLHOC) {
            let _sector;
            const verLH = (pVerLHOC == undefined) ? true : pVerLHOC;
            if (verLH == true) {
                switch (pName) {
                    case 'lstOrganigrama':
                        _sector = <aside className="side-bar"> <div className='loader'> </div> </aside>
                        break;
                    case 'lstEmpresas':
                        const logopng = ImagenesRutas.Logo;
                        _sector = <div className="row">
                            <div className="col-xs-4">
                                <img className="logo-ld" src={logopng} alt="Logical Data" />
                            </div>
                            <div className="col-xs-4">
                                <div className='loaderHead'> </div>
                            </div>
                            <div className="col-xs-4">
                                {/*<h2>{nombreSistema}</h2>*/}
                            </div>
                        </div>
                        break;
                    case 'datosMenu':
                        _sector = <div className="wsmenucontainer clearfix">
                            <div className="overlapblackbg"></div>
                            <div className="wsmobileheader clearfix"> <a id="wsnavtoggle" className="animated-arrow"><span></span></a> </div>
                            <div className="headerfull">
                                {/*Main Menu HTML Code-->*/}
                                <div className="wsmain">
                                    <nav className="wsmenu clearfix">
                                        <ul className="mobile-sub wsmenu-list">
                                            <div className='loaderMenu'> </div>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        break;
                    case 'dataRows':
                        _sector = <div className='loaderLista'> </div>
                        break;
                    case 'datos':
                        _sector = <div className='loader'> </div>
                        break;
                    case 'listaFiltro':
                        _sector = <div className='loader'> </div>
                        break;
                    case 'treeData':
                        _sector = <div className='loader'> </div>
                        break;
                    case 'listaArea':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;

                    case 'Datos':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;
                    case 'listaParamPlan':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;
                    case 'listaRenta':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;
                    case 'listaEmbargo':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;
                    case 'listaAdelanto':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;
                    case 'listaEmpleados':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;
                    case 'listaPlanilla':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;

                    case 'listaDatos':
                        _sector = <div className={"col-sm-12 col-md-12"}>
                            <div className="form-group">
                                <div className='loader'> </div>
                            </div>
                        </div>
                        break;
                    case '':
                        _sector = <WrapedComponent {... this.props} />
                        break;
                }
            } else {
                _sector = <WrapedComponent {... this.props} />
            }

            return _sector;

        }


        isEmpty(prop) {
            return (
                prop === null ||
                prop === undefined ||
                (prop.hasOwnProperty('length') && prop.length === 0) ||
                (prop.constructor === Object && Object.keys(prop).length === 0)
            );
        }



        render() {
            return this.isEmpty(this.props[propName]) ?
                this.cargandoSector(propName, this.props.verLHOC) : <WrapedComponent {... this.props} />
        }
    }
}

export default LoaderHOC;